import React from 'react';
import { Modal } from '../../../components/common/Modal';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner';
import { SupplierForm } from '../../purchasing/SupplierForm';
import type { Supplier } from '../../../types/supplier';
import { useLanguage } from '../../../features/language/useLanguage';

interface SupplierModalProps {
  isOpen: boolean;
  onClose: () => void;
  supplier: Supplier | null;
  loading: boolean;
  error: string | null;
}

export const SupplierModal: React.FC<SupplierModalProps> = ({
  isOpen,
  onClose,
  supplier,
  loading,
  error,
}) => {
  const { t } = useLanguage();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={supplier?.name ? `${t('purchasing.sampleList.table.supplier')}: ${supplier.name}` : t('purchasing.sampleList.table.supplier')}
      maxWidth="xl"
    >
      {loading ? (
        <LoadingSpinner text={t('purchasing.supplierList.loading')} />
      ) : error ? (
        <div className="text-sm text-red-600">{error}</div>
      ) : supplier ? (
        <SupplierForm initialData={supplier} readOnly onCancel={onClose} />
      ) : (
        <div className="text-sm text-gray-500">{t('dashboard.greenBeanLotsModal.noSupplierSelected')}</div>
      )}
    </Modal>
  );
};
